import { combineReducers } from 'redux'

import * as ActionTypes from './actionTypes'

export const NAME = 'sigevents'

const sigEventsIsLoading = (state = true, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_START:
      return true
    case ActionTypes.FETCH_FAILURE:
    case ActionTypes.FETCH_SUCCESS:
      return false
    default:
      return state
  }
}

const byId = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS: {
      let byId = {}
      action.events.forEach((e) => (byId[e.id] = e))
      return byId
    }
    case ActionTypes.ADD_EVENT:
    case ActionTypes.EDIT_EVENT: {
      let byId = { ...state }
      byId[action.event.id] = action.event
      return byId
    }
    default:
      return state
  }
}

const allKeys = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      return action.events.map((e) => e.id)
    case ActionTypes.ADD_EVENT:
      if (state.includes(action.event.id)) return state
      else return [...state, action.event.id]
    default:
      return state
  }
}

const incidentKeys = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.FETCH_INCIDENTS_SUCCESS:
      return action.incidents.map((i) => i.id)
    default:
      return state
  }
}

const incidentsById = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_INCIDENTS_SUCCESS:
      let byId = {}
      action.incidents.forEach((i) => (byId[i.id] = i))
      return byId
    default:
      return state
  }
}

const incidentsVisible = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_INCIDENTS_SUCCESS:
      let byId = {}
      action.incidents.forEach((i) => (byId[i.id] = true))
      return byId
    case ActionTypes.SHOW_INCIDENT:
      return {
        ...state,
        [action.incidentId]: true,
      }
    case ActionTypes.HIDE_INCIDENT:
      return {
        ...state,
        [action.incidentId]: false,
      }
    default:
      return state
  }
}

const initialSelected = { eventIds: [], current: 0 }
const selected = (state = initialSelected, action) => {
  const { eventIds, current } = state
  switch (action.type) {
    case ActionTypes.SELECT_EVENTS:
      return {
        eventIds: action.eventIds,
        current: 0,
      }
    case ActionTypes.NEXT_EVENT:
      return {
        ...state,
        current: current + (current < eventIds.length - 1 ? 1 : 0),
      }
    case ActionTypes.PREV_EVENT:
      return {
        ...state,
        current: current - (current > 0 ? 1 : 0),
      }
    case ActionTypes.CLEAR_SELECTION:
    case ActionTypes.ADD_EVENT:
    case ActionTypes.EDIT_EVENT:
      return initialSelected
    default:
      return state
  }
}

const initialEditor = {
  incidentId: -1,
  subject: '',
  address: '',
  latitude: 0,
  longitude: 0,
  description: '',
  error: '',
}
const editor = (state = initialEditor, action) => {
  switch (action.type) {
    case ActionTypes.OPEN_EDITOR:
      return action.event || initialEditor
    case ActionTypes.CLOSE_EDITOR:
    case ActionTypes.ADD_EVENT:
    case ActionTypes.EDIT_EVENT:
      return initialEditor
    case ActionTypes.SET_INCIDENT_ID:
      return { ...state, incidentId: action.incidentId }
    case ActionTypes.SET_SUBJECT:
      return { ...state, subject: action.subject }
    case ActionTypes.SET_ADDRESS:
      return { ...state, address: action.address }
    case ActionTypes.SET_DESCRIPTION:
      return { ...state, description: action.description }
    case ActionTypes.SET_POSITION:
      return {
        ...state,
        address: action.address || state.address,
        latitude: action.latitude,
        longitude: action.longitude,
      }
    case ActionTypes.SET_ERROR:
      return {
        ...state,
        error: action.error,
      }
    default:
      return state
  }
}

const sigevents = combineReducers({
  byId,
  allKeys,
  sigEventsIsLoading,
  selected,
  editor,
  incidentKeys,
  incidentsById,
  incidentsVisible,
})

export default sigevents
